import {
    CodeBlock, BlockType, SettingType, ValidationMessage, SettingState,
} from '@appblocks/codegeneration/types';

import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import * as micropython from './micropython';
import * as tios from './tios';
import * as zephyr from './zephyr';
import * as simulator from './simulator';
export default class Command extends BaseFeature {
    constructor() {
        super();
        this.name = 'Command';
        this.id = 'command';
        this.requirements = ['tios'];
        const settings = [
            {
                id: 'NAME',
                name: 'ID',
                settingType: SettingType.NAME,
                required: true,
                min: 1,
                default: 'CMD',
            },
            {
                id: 'DESCRIPTION',
                name: 'Description',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    initSettings(project?: any, parentFeature?: any): void {
        super.initSettings(project, parentFeature, 'NAME');
    }

    getName(): string {
        const desc = this.getSettingValue('DESCRIPTION');
        return `${this.getSettingValue('NAME')}${desc && ` (${desc})`}`;
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }
}
